import type { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';
import { getLocaleFromLanguageRegionCode } from './languageTypeModifiers';
import { localizedPathComponents } from './localizedPathComponents';

/**
 * Localizes a url with a language prefix to the correct localized url. Only supports trail and parks paths.
 * @param urlWithLanguagePrefix - The url with a language prefix (ex: /fr/trail/{slug})
 * @param languageRegionCode - The language region code to localize the url to
 * @returns The localized url (ex: /fr/randonnee/{slug})
 */
export function localizeUrlComponents(urlWithLanguagePrefix: string, languageRegionCode: LanguageRegionCode): string {
  const localePathPrefix = getLocaleFromLanguageRegionCode(languageRegionCode);
  const localizedPaths = localizedPathComponents[localePathPrefix];
  if (languageRegionCode === 'en-US' || !localizedPaths) {
    return urlWithLanguagePrefix;
  }

  // Pattern distinguishes between /trail/new and /trail/new-zealand/...
  const matchRegex = new RegExp(`^\\/${localePathPrefix}\\/(trail\\/new|trail|parks)($|\\/.*|\\?.*)`);
  const match = urlWithLanguagePrefix.match(matchRegex);
  // Certain cases that match the above do not support translated components
  const noMatchRegex = /\/(edit)($|\?.*)/;
  if (match && localizedPaths[match[1]] && !urlWithLanguagePrefix.match(noMatchRegex)) {
    return `/${localePathPrefix}/${localizedPaths[match[1]]}${match[2]}`;
  }

  return urlWithLanguagePrefix;
}
